import React, { useEffect, useState } from 'react';
import BaseLayout from '../../layouts/BaseLayout';
import { useApiHandler } from '../../utils/apiHandler';
import TaskList from './components/TaskList';
import EmployeeList from './components/EmployeeList';
import StatCard from './components/StatCard';
import ProjectList from './components/ProjectList';
import ActiveEmployees from './components/ActiveEmployees';

function Dashboard() {
  const [tasks, setTasks] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [activeEmployees, setActiveEmployees] = useState([]);
  const [activeCount, setActiveCount] = useState(0);
  const [stats, setStats] = useState({
    totalEmployees: 0,
    totalTasks: 0,
    pendingTasks: 0,
    completedTasks: 0,
    performance: '0%',
  });
  const apiHandler = useApiHandler();

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await apiHandler.get('/admin/admin-stats');
        const { data } = response;
        if (data.success) {
          setStats({
            totalEmployees: data.data.totalEmployees,
            totalTasks: data.data.totalTasks,
            pendingTasks: data.data.pendingTasks,
            completedTasks: data.data.completedTasks,
            performance: data.data.performance,
          });
          setTasks(data.data.lastProjects);
          setEmployees(data.data.lastEmployees);
        }
      } catch (err) {
        console.log(err.message || 'An unexpected error occurred.');
      }
    };

    const fetchActiveEmployees = async () => {
      try {
        const response = await apiHandler.get('/admin/employee-logged');
        const { data } = response;
        if (data.success) {
          setActiveEmployees(data.data);  // set the active employees array
          setActiveCount(data.data.length);  // activeCount is simply the length of the active employees array
        }
      } catch (err) {
        console.log(err.message || 'An unexpected error occurred.');
      }
    };

    fetchStats();
    fetchActiveEmployees();
  }, []);

  return (
    <BaseLayout>
      <div className="min-h-screen bg-gray-50">
        <main className="max-w-7xl mx-auto px-4 py-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
            <StatCard
              title="Total Employees"
              value={stats.totalEmployees}
              iconType="users"
              trend="+5%"
              color="blue"
            />
            <StatCard
              title="Total Tasks"
              value={stats.totalTasks}
              iconType="checkCircle"
              trend="-2%"
              color="green"
            />
            <StatCard
              title="Pending Tasks"
              value={stats.pendingTasks}
              iconType="clock"
              trend="+1%"
              color="yellow"
            />
            <StatCard
              title="Completed Tasks"
              value={stats.completedTasks}
              iconType="checkCircle"
              trend="+10%"
              color="green"
            />
          </div>

          {/* Active Employees Section */}
          <div className="mb-6">
            <ActiveEmployees
              activeCount={activeCount}
              activeEmployees={activeEmployees}
            />
          </div>

          <EmployeeList employees={employees} />
          <ProjectList projects={tasks} />
        </main>
      </div>
    </BaseLayout>
  );
}

export default Dashboard;